export default __webpack_public_path__ + "static/media/overflowMenu.9a75ca42.svg";